<div class="last-editor-field">
  <label class="last-editor-label">LAST EDITOR</label>
  <button
    mat-stroked-button
    type="button"
    class="last-editor-button"
    [matMenuTriggerFor]="logMenu"
    [disabled]="!hasLogs"
  >
    <span *ngIf="hasLogs" class="last-editor-value">
      {{ displayInitials }}&nbsp;&ndash;&nbsp;{{ latestLog.date | date: 'MM/dd/yyyy': 'PST' }}
    </span>
  </button>
  <mat-menu #logMenu="matMenu" panelClass="log-menu-panel">
    <mat-list role="list" dense>
      <mat-list-item
        role="listitem"
        *ngFor="let log of sortedLogs"
        style="text-transform: uppercase; font-size: smaller"
      >
        <span class="log-row">
          <ng-container *ngIf="log.item">{{ formatLogItem(log.item) }}&nbsp;&ndash;&nbsp;</ng-container>
          {{ log.initials }}
          &nbsp;&ndash;&nbsp;{{ log.date | date: 'MM/dd/yyyy': 'PST' }}
          <ng-container *ngIf="log.notes">&nbsp;&ndash;&nbsp;{{ log.notes }}</ng-container>
        </span>
      </mat-list-item>
    </mat-list>
  </mat-menu>
</div>
